module.exports = __webpack_public_path__ + "img/boa.ea7f158e.svg";